import React from 'react';
import { contact, profile } from '../../data/portfolio';
import profileImage from './123.jpg';
import './MainSection.css';

function MainSection() {
  return (
    <section id="about" className="hero-section" aria-labelledby="hero-title">
      <div className="hero-inner">
        <div className="hero-copy">
          <p className="hero-eyebrow">{profile.experience}</p>
          <h1 id="hero-title">{profile.headline}</h1>
          <p className="hero-introduction">{profile.introduction}</p>

          <div className="hero-actions">
            <a className="primary-action" href="#career">경력 보기</a>
            <a className="text-action" href={contact.github} target="_blank" rel="noreferrer">
              GitHub <span aria-hidden="true">↗</span>
            </a>
          </div>
        </div>

        <figure className="portrait-frame">
          <img src={profileImage} alt="전성진 프로필" />
        </figure>
      </div>

    </section>
  );
}

export default MainSection;
